import React from 'react';
import { FiChevronDown, FiChevronRight, FiChevronUp } from 'react-icons/fi';
import { AiFillFolderOpen, AiOutlineFolder } from 'react-icons/ai';
import { FinderFolder, FinderFolderIcon, FinderFolderLabel } from '@/components/custom/finder';
import { IconWrapper } from '@/components/custom/icon';
import usePlayfulTeacher from '@/hooks/usePlayfulTeacher';
import { cn } from '@/lib/utils';

export function LessonPlanFolder(props) {
  const { name, subFolders, isExpanded, setIsExpanded, onClick, isOpenFolder, folderId, setIdOpenedSubFolder, setCurrentFolder } = props;
  const playfulTeacher = usePlayfulTeacher();

  const chevronIcon = isOpenFolder ? <FiChevronRight /> : isOpenFolder || isExpanded === folderId ? <FiChevronUp /> : <FiChevronDown />;

  const handleToggle = e => {
    e.stopPropagation();

    if (subFolders?.length > 0) {
      setIsExpanded(prev => (prev === folderId ? null : folderId));
      setIdOpenedSubFolder(null);
      setCurrentFolder(null);
    }
  };

  const isPlayfulSelected = playfulTeacher && isOpenFolder;
  const playfulIconClassName = isPlayfulSelected ? 'text-white' : 'text-[var(--color-mission-text)]';

  return (
    <FinderFolder
      isOpen={isOpenFolder}
      onClick={onClick}
      style={isPlayfulSelected ? { background: 'var(--gradient-btn-continue)' } : undefined}
    >
      {isOpenFolder ? (
        <FinderFolderIcon className={playfulTeacher ? playfulIconClassName : undefined}>
          <AiFillFolderOpen />
        </FinderFolderIcon>
      ) : (
        <FinderFolderIcon className={playfulTeacher ? playfulIconClassName : undefined}>
          <AiOutlineFolder />
        </FinderFolderIcon>
      )}

      <FinderFolderLabel
        title={name}
        className={isPlayfulSelected ? 'text-white' : undefined}
      >
        {name}
      </FinderFolderLabel>

      <IconWrapper
        size="sm"
        asChild
        className={playfulTeacher ? cn('bg-transparent', playfulIconClassName) : undefined}
      >
        <button onClick={handleToggle}>{chevronIcon}</button>
      </IconWrapper>
    </FinderFolder>
  );
}
